/**
 * This component renders the footer for pages
 * TODO Finalise content
 */
import React from "react";
import HomeGradient from "../home/HomeGradient";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <div className="dark:pt-4 bg-dark-1">
      <HomeGradient />
      <div className="footer bg-light-4 dark:bg-dark-1 pb-2">
        <div className="sponsor-logos flex flex-row justify-center items-center py-3">
        <img
            src="/assets/logos/fisu.png"
            alt="FISU"
            className="dark:rounded sm:h-16 h-12 icons2:h-24 mx-1 sm:mx-3 p-1"
          />
          <img
            src="/assets/logos/ihuk.png"
            alt="IHUK"
            className="dark:rounded sm:h-16 h-12 icons2:h-24 mx-1 sm:mx-3 p-1"
          />
          
          <img
            src="/assets/logos/eiha.png"
            alt="EIHA"
            className="dark:rounded sm:h-16 h-12 icons2:h-24 mx-1 sm:mx-3 p-1"
          />
        </div>

        {/* Disclaimer text TODO update */}

        <div className="flex flex-col justify-center items-center px-2">
          <p className="xxs:text-xs text-xxxs text-center text-darken text-bold leading-tight">
            © {new Date().getFullYear()} BUIHA
          </p>
          <p className="xxs:text-xs text-xxxs text-center text-darken text-bold leading-tight">
            BUIHA is not responsible for content submitted via external sources
          </p>
          <p className="xxs:text-xs text-xxxs text-center text-darken text-bold leading-tight">
            All content remains the property of its rightful owner
          </p>

          {/*<div className="flex flex-row justify-center items-center mt-2">*/}
          {/*  <p className="text-center xxs:text-xs text-xxxs text-darken text-center text-bold pr-1 leading-tight">*/}
          {/*    Built by Zac Jones & David Rogers*/}
          {/*  </p>*/}
          {/*</div>*/}
          <div className="flex flex-row justify-center items-center mt-0.5">
            <Link
              to="/contributors"
              className="mx-2 xxs:text-xs text-xxxs text-darken underline text-center text-bold leading-tight hover:text-buiha-red dark:hover:text-dark-5 ease-in-out duration-200 font-normal"
            >
              Website Contributors
            </Link>
            {/*<Link*/}
            {/*  to="/gdpr"*/}
            {/*  className="mx-2 xxs:text-xs text-xxxs text-darken underline text-center text-bold leading-tight hover:text-buiha-red dark:hover:text-dark-5 ease-in-out duration-200 font-normal"*/}
            {/*>*/}
            {/*  GDPR Statement*/}
            {/*</Link>*/}
          </div>
        </div>
      </div>
    </div>
  );
};
export default Footer;
